export enum BusinessType {
  ONG = 'ONG',
  AUTONOMOUS = 'AUTONOMOUS',
  COMPANY = 'COMPANY',
}
